<template>
  <v-card color="basil">
    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
    >
      <v-tab
        v-for="item in items"
        :key="item.label"
      >
        {{ item.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="t in items"
        :key="t.key"
      >
        <v-card flat>
          <v-card-text v-if="t.key === 'users'">
            <div>
              <users-tab :filters-options="filters" />
            </div>
          </v-card-text>
          <v-card-text v-else-if="t.key === 'analytics'">
            <div>
              <analytics-tab :filters-options="filters" />
            </div>
          </v-card-text>
          <v-card-text v-else-if="t.key === 'reports'">
            <div>
              <reports-tab :filters-options="filters" />
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
export default {
  name: "UsersTabsIndex",
  components: {
    UsersTab: () => import("./UsersTab.vue"),
    AnalyticsTab: () => import("./Analytics.vue"),
    ReportsTab: () => import("./Reports.vue"),
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tab: null,
      items: [
        { key: "users", label: "Users (Primary)" },
        { key: "analytics", label: "Analytics" },
        { key: "reports", label: "Reports" },
      ],
    };
  },
  computed: {},
  methods: {},
};
</script>
